import { createContext, useContext } from "react";

import { Organisation } from "@nens/threedi/openapi-client";

export type SwitchOrganisation = (organisation: Organisation) => void;

interface TenantSwitchContextValue {
  tenant: string;
  switchOrganisation: SwitchOrganisation;
}

export const TenantSwitchContext = createContext<TenantSwitchContextValue>({
  tenant: "",
  switchOrganisation: () => undefined,
});

export const useTenantSwitch = () => useContext(TenantSwitchContext);
